import { useEffect, useState } from 'react'
import api from '../utils/api'

const useRegister = (email, password, repeatPassword, image, submit) => {
  const [registerRequest, setRegisterRequest] = useState({
    data: null,
    isLoading: false,
    error: null,
  })

  useEffect(() => {
    setRegisterRequest((currentRegisterRequest) => ({
      ...currentRegisterRequest,
      isLoading: false,
      error: null,
    }))

    async function login() {
      if (email && password && submit) {
        try {
          setRegisterRequest((currentRegisterRequest) => ({
            ...currentRegisterRequest,
            isLoading: true,
            error: null,
          }))
          const response = await api.post(
            '/login',
            { email, password, repeatPassword, image },
            { includeToken: false }
          )
          setRegisterRequest({
            data: response.data,
            isLoading: false,
            error: response.error,
          })
        } catch (error) {
          setRegisterRequest({
            data: null,
            isLoading: false,
            error,
          })
        }
      }
    }
    login()
  }, [email, password, repeatPassword, submit, image])

  return registerRequest
}

export default useRegister
